var map = {
	"./video steel.mp4": "sChM"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "I1eD";


//////////////////
// WEBPACK FOOTER
// ./src/customization/SteelOApp/pages/Login/Assets/Video ^\.\/.*$
// module id = I1eD
// module chunks = 0